import { format } from "date-fns";

export const ppProjectTaskTypes = [
    { id: "portfolio", label: "Portfolio" },
    { id: "programme", label: "Programme" },
    { id: "project", label: "Project" },
    { id: "milestone", label: "Milestone" } // keep built-in
];

export const ppProjectColumns = [
    {
        id: "text",
        //header: "Project",
        header: "Portfolio / Programme / Project",
        width: 350
    }
];

export const app03EpicTypes = [
    { id: "epic", label: "Epic" },
    { id: "milestone", label: "Milestone" } // keep built-in
];

export const app03EpicColumns = [
    {
        id: "text",
        header: "Epic",
        width: 350
    }
];


/* ===========================
   ZOOM CONFIG (Official demo structure)
=========================== */
const quarterTemplate = (start: Date) => {
    const quarter = Math.floor(start.getMonth() / 3) + 1;
    return `Q${quarter}`;
};

const dayStyle = (d: Date) => {
    const day = d.getDay() === 5 || d.getDay() === 6;
    return day ? "sday" : "";
};

const hoursTemplate = (a: Date, b: Date) =>
    `${format(a, "HH:mm")} - ${format(b, "HH:mm")}`;


export enum GanttZoomLevel {
    Year = 0,
    YearQuarter = 1,
    QuarterMonth = 2,
    MonthWeek = 3,
    MonthDay = 4,
    Day6Hours = 5,
    DayHour = 6
}

export const svarGanttZoomConfig = {
    level: GanttZoomLevel.Year, // Default
    levels: [
        //Year 1
        {
            minCellWidth: 180,
            maxCellWidth: 400,
            scales: [{ unit: "year", step: 1, format: "%Y" }],
        },

        //YearQuarter 2
        {
            minCellWidth: 150,
            maxCellWidth: 350,
            scales: [
                { unit: "year", step: 1, format: "%Y" },
                { unit: "quarter", step: 1, format: quarterTemplate },
            ],
        },

        //QuarterMonth 3
        {
            minCellWidth: 120,
            maxCellWidth: 300,
            scales: [
                { unit: "quarter", step: 1, format: quarterTemplate },
                { unit: "month", step: 1, format: "%F %Y" },
            ],
        },

        //MonthWeek 4
        {
            minCellWidth: 90,
            maxCellWidth: 250,
            scales: [
                { unit: "month", step: 1, format: "%F %Y" },
                { unit: "week", step: 1, format: "Week %W" },
            ],
        },

        //MonthDay 5
        {
            minCellWidth: 60,
            maxCellWidth: 200,
            scales: [
                { unit: "month", step: 1, format: "%F %Y" },
                { unit: "day", step: 1, format: "%j, %D", css: dayStyle },
            ],
        },

        //Day6Hours 6
        {
            minCellWidth: 40,
            maxCellWidth: 120,
            scales: [
                { unit: "day", step: 1, format: "%j, %D", css: dayStyle },
                { unit: "hour", step: 6, format: hoursTemplate },
            ],
        },

        //DayHour 7
        {
            minCellWidth: 25,
            maxCellWidth: 100,
            scales: [
                { unit: "day", step: 1, format: "%j, %D", css: dayStyle },
                { unit: "hour", step: 1, format: "%H:%i" },
            ],
        },
    ],
};

// Highlight weekends
export const ganttHighlightTime = (date: Date, unit: string) => {
    if (unit !== "day") return "";

    const weekday = date.getDay();

    return weekday === 6 || weekday === 0 ? "wx-weekend" : "";
};